// extracted by mini-css-extract-plugin
export default {"triggerArea":"vnOCUQg_iGPsfTfCBN_x","agentInfo":"YmMW6CX9uSrfpOBjghib","selectNew":"NtcnbAWuy2cCnyrtNbZa","image":"SEm9CF23Aqum_oEGtXdr","moreOrLess":"o2RyZHZfyAvohZo_YISj"};